import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ height: number }>()((theme, { height }) => ({
  sankeyWrapper: {
    height: height,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export default useStyles;
